import { Pipe } from '@angular/core';
var WithoutPipe = (function () {
    function WithoutPipe() {
    }
    WithoutPipe.prototype.transform = function (input, args) {
        if (args === void 0) { args = []; }
        return Array.isArray(input)
            ? input.filter(function (e) { return !~args.indexOf(e); })
            : input;
    };
    return WithoutPipe;
}());
export { WithoutPipe };
WithoutPipe.decorators = [
    { type: Pipe, args: [{ name: 'without' },] },
];
/** @nocollapse */
WithoutPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=without.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/without.js
// module id = 216
// module chunks = 4